import type { Tokens, UdsTokens } from '../../styled'

interface StyledProps {
  theme: {
    tokens: Tokens
    udsTokens: UdsTokens
  }
}

export type TokenFunction = (props: StyledProps) => string | number

/**
 * @deprecated This function serves legacy token set. For consume UDS tokens use `tok` function.
 */
export const tk = (tokenName: keyof Tokens) => (props: StyledProps) => props.theme.tokens[tokenName]

export const tok = (tokenName: keyof UdsTokens) => (props: StyledProps) => props.theme.udsTokens[tokenName]

export type UdsTokensNumber = {
  [K in keyof UdsTokens]: UdsTokens[K] extends number ? K : never;
}[keyof UdsTokens]

export function tokPx(tokenName: UdsTokensNumber) {
  return ({ theme }: StyledProps) =>
    theme.udsTokens[tokenName] ? `${theme.udsTokens[tokenName]}px` : '0'
}

type SpaceUdsToken =
  | 'primitives_space_0'
  | 'primitives_space_2'
  | 'primitives_space_4'
  | 'primitives_space_6'
  | 'primitives_space_8'
  | 'primitives_space_12'
  | 'primitives_space_16'
  | 'primitives_space_20'
  | 'primitives_space_24'
  | 'primitives_space_28'
  | 'primitives_space_32'
  | 'primitives_space_40'
  | 'primitives_space_44'
  | 'primitives_space_48'
  | 'primitives_space_56'
  | 'primitives_space_64'
  | 'primitives_space_80'
  | 'primitives_space_96'

type TokenPixelHelper<T> = (tokenName: T) => ({ theme }: StyledProps) => string
export const space: TokenPixelHelper<SpaceUdsToken> = tokenName => tokPx(tokenName)

type BreakpointUdsToken =
  | 'primitives_breakpoint_s_min'
  | 'primitives_breakpoint_s_max'
  | 'primitives_breakpoint_m_min'
  | 'primitives_breakpoint_m_max'
  | 'primitives_breakpoint_l_min'

export const breakpoint: TokenPixelHelper<BreakpointUdsToken> = tokenName => tokPx(tokenName)

type MinMediaQueryUdsToken = 'primitives_breakpoint_m_min' | 'primitives_breakpoint_l_min'

export function mqMin(tokenName: MinMediaQueryUdsToken) {
  return ({ theme }: StyledProps) =>
    theme.udsTokens[tokenName] ? `(min-width: ${theme.udsTokens[tokenName]}px)` : '0'
}

type MaxMediaQueryUdsToken = 'primitives_breakpoint_s_max'

export function mqMax(tokenName: MaxMediaQueryUdsToken) {
  return ({ theme }: StyledProps) =>
    theme.udsTokens[tokenName] ? `(max-width: ${theme.udsTokens[tokenName]}px)` : '0'
}

export type SemanticsTextColorUdsToken =
  | 'semantics_content_color'
  | 'semantics_content_secondary_color'

export function textColor(tokenName: SemanticsTextColorUdsToken) {
  return tok(tokenName)
}
